export default "__VITE_ASSET__71b2809c__"